import { KeyValue } from "@/main/models/common";
import { SystemApplicationTypes, SystemApplicationActionTypes } from "./systemApplicationTypes";

export function getSystemApplication(): SystemApplicationActionTypes {
	return {
		type: SystemApplicationTypes.GET_SYSTEM_APPLICATION,
	};
}

export function saveSystemApplication(
	data: KeyValue[] | null,
	isError: boolean,
	errorMessages: string[] | null,
): SystemApplicationActionTypes {
	return {
		type: SystemApplicationTypes.SAVE_SYSTEM_APPLICATION,
		payload: { data, isError, errorMessages },
	};
}

export function resetReducerSystemApplication(): SystemApplicationActionTypes {
	return {
		type: SystemApplicationTypes.RESET_REDUCER_SYSTEM_APPLICATION,
	};
}
